// Date handling for vacancy details page
export default function useVacancyDates(vacancy: Partial<Vacancy>) {
  const upcomingDates = computed(() => {
    if (!vacancy.dates?.length) return []
    const now = new Date()
    now.setHours(0, 0, 0, 0)

    return vacancy.dates
      .filter(date => new Date(date) >= now)
      .sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
  })

  const datesAreInTheSameMonth = computed(() => {
    const dates = vacancy.dates

    if (dates && dates.length > 0) {
      const firstDate = new Date(dates[0])
      const firstMonth = firstDate.getMonth()
      const firstYear = firstDate.getFullYear()

      return dates.every((dateStr) => {
        const date = new Date(dateStr)
        return date.getMonth() === firstMonth && date.getFullYear() === firstYear
      })
    }
  })

  return { upcomingDates, datesAreInTheSameMonth }
}
